"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseTransform_1 = require("./BaseTransform");

var Query_1 = require("../Query");

var get_1 = require("../../utils/get");

var typeChecks_1 = require("../../utils/typeChecks");

var isArrayLike_1 = require("../../utils/isArrayLike");

var formatter_1 = require("../../utils/formatter");

var PivotTransform =
/** @class */
function (_super) {
  __extends(PivotTransform, _super);

  function PivotTransform() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.keysToRemove = [];
    _this.fieldHasValue = false;
    return _this;
  }

  PivotTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
    var response = [];

    if (queryResponse) {
      if (isArrayLike_1.isArrayLike(queryResponse) || typeof queryResponse === 'object') {
        var elements = queryResponse;

        if (!isArrayLike_1.isArrayLike(queryResponse)) {
          elements = [queryResponse];
        }

        if (elements.length > 0) {
          if (this.options.pivotGroupByKey) {
            response = this.pivotGroupByElements(elements, executionOptions);
          } else {
            response.push.apply(response, this.pivotElement(elements, executionOptions));
          }
        }
      }
    }

    return response;
  };

  PivotTransform.prototype.pivotElement = function (elements, executionOptions) {
    var fields = this.options.fields;
    var response = [];

    for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
      var field = fields_1[_i];
      var _a = field,
          key = _a.key,
          name_1 = _a.name,
          isPrimary = _a.isPrimary,
          format = _a.format;
      var nameValue = key;

      if (name_1) {
        var nameQuery = new Query_1.Query(name_1);
        nameValue = nameQuery.execute(executionOptions);
      }

      var record = {
        name: nameValue
      };

      for (var _b = 0, elements_1 = elements; _b < elements_1.length; _b++) {
        var element = elements_1[_b];
        this.fieldHasValue = false;
        var result = this.getRecord(element, key, isPrimary, format, executionOptions);
        record = Object.assign(record, result);
      }

      if (this.fieldHasValue) {
        response.push(record);
      }
    }

    return this.cleanUpKeys(response);
  };

  PivotTransform.prototype.pivotGroupByElements = function (elements, executionOptions) {
    var _a = this.options,
        fields = _a.fields,
        pivotGroupByKey = _a.pivotGroupByKey; // Array.from is a work around without having to set the downlevelIteration flag in ts config

    var pivotGroupByKeyValues = __spreadArrays(Array.from(new Set(elements.map(function (element) {
      return element[pivotGroupByKey];
    }))));

    var response = [];

    var _loop_1 = function _loop_1(pivotGroupByKeyValue) {
      for (var _i = 0, fields_2 = fields; _i < fields_2.length; _i++) {
        var field = fields_2[_i];
        var _a = field,
            key = _a.key,
            name_2 = _a.name,
            isPrimary = _a.isPrimary,
            format = _a.format;
        var record = {};
        var nameValue = key;
        record[pivotGroupByKey] = pivotGroupByKeyValue;

        if (name_2) {
          var nameQuery = new Query_1.Query(name_2);
          nameValue = nameQuery.execute(executionOptions);
        }

        record['name'] = nameValue; // Only get elements for this group

        var groupedElements = elements.filter(function (element) {
          return element[pivotGroupByKey] === pivotGroupByKeyValue;
        });

        for (var _b = 0, groupedElements_1 = groupedElements; _b < groupedElements_1.length; _b++) {
          var groupedElement = groupedElements_1[_b];
          this_1.fieldHasValue = false;
          var result = this_1.getRecord(groupedElement, key, isPrimary, format, executionOptions, pivotGroupByKeyValue);
          record = Object.assign(record, result);
        }

        if (this_1.fieldHasValue) {
          response.push(record);
        }
      }
    };

    var this_1 = this;

    for (var _i = 0, pivotGroupByKeyValues_1 = pivotGroupByKeyValues; _i < pivotGroupByKeyValues_1.length; _i++) {
      var pivotGroupByKeyValue = pivotGroupByKeyValues_1[_i];

      _loop_1(pivotGroupByKeyValue);
    }

    return this.cleanUpKeys(response, pivotGroupByKey);
  };

  PivotTransform.prototype.getRecord = function (element, key, isPrimary, format, executionOptions, groupKey) {
    var _a = this.options,
        pivotKey = _a.pivotKey,
        pivotValueType = _a.pivotValueType,
        rawFieldKeys = _a.rawFieldKeys;
    var record = {};

    if (rawFieldKeys) {
      for (var _i = 0, rawFieldKeys_1 = rawFieldKeys; _i < rawFieldKeys_1.length; _i++) {
        var rawFieldKey = rawFieldKeys_1[_i];
        record[rawFieldKey] = get_1.get(element, rawFieldKey);
      }
    }

    var fieldKey = get_1.get(element, pivotKey);

    if (!this.keysToRemove.includes(fieldKey)) {
      var fieldValue = get_1.get(element, key);

      if (pivotValueType) {
        if (pivotValueType === 'number') {
          fieldValue = parseFloat(fieldValue);
        }

        if (pivotValueType === 'string') {
          fieldValue = fieldValue.toString();
        }
      }

      if (!typeChecks_1.isNullOrUndefined(fieldValue) && !Number.isNaN(fieldValue)) {
        if (format) {
          var type = format.type,
              transforms = format.transforms,
              options = format.options;
          var culture = executionOptions.culture,
              currency = executionOptions.currency,
              translate = executionOptions.translate;
          fieldValue = formatter_1.default(type, culture, currency, options, fieldValue, transforms, translate);
        }

        this.fieldHasValue = true;
        record[fieldKey] = fieldValue;
      } else if (isPrimary) {
        var keyToRemove = groupKey ? fieldKey + "-" + groupKey : fieldKey;
        this.keysToRemove.push(keyToRemove);
      }
    }

    return record;
  };

  PivotTransform.prototype.cleanUpKeys = function (response, pivotGroupByKey) {
    var _a = this.options.rawFieldKeys,
        rawFieldKeys = _a === void 0 ? [] : _a;
    var result = response; // This will track all fields that are undefined or null for the primary record
    // If the primary record doesn't have a value then we ignore the values for the
    // other records. Usually needed when a fund does not have a value but its benchmarks
    // but we don't want to show the benchmark values then.

    if (this.keysToRemove && this.keysToRemove.length > 0) {
      var staticKeys = __spreadArrays(['name'], rawFieldKeys);

      for (var i = 0; i < response.length; i++) {
        var record = response[i];

        for (var _i = 0, _b = this.keysToRemove; _i < _b.length; _i++) {
          var keyToRemove = _b[_i];

          if (pivotGroupByKey) {
            var keys = keyToRemove.split('-');

            if (record[pivotGroupByKey] === keys[1]) {
              delete record[keys[0]];
            }
          } else {
            delete record[keyToRemove];
          }
        }

        var remainingKeys = Object.keys(record);
        var hasValue = false;

        for (var _c = 0, remainingKeys_1 = remainingKeys; _c < remainingKeys_1.length; _c++) {
          var remainingKey = remainingKeys_1[_c];
          hasValue = !staticKeys.includes(remainingKey);

          if (hasValue) {
            break;
          }
        }

        if (!hasValue) {
          response.splice(i, 1);
          i--;
        }
      }
    }

    return result;
  };

  return PivotTransform;
}(BaseTransform_1.BaseTransform);

exports.PivotTransform = PivotTransform;